module.exports = __webpack_public_path__ + "static/media/flag.97660163.svg";